// extracted by mini-css-extract-plugin
export default {"waveformContainer":"VoiceCommWaveform_waveformContainer__sLg18"};